import React from 'react';
import { motion } from 'framer-motion';
// import Logo from '../assets/logo.png'; // Replace with your actual logo/image path

const Loader = () => {
  // Container fade-in
  const containerVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: { duration: 1.2, ease: 'easeOut' },
    },
  };

  // Image gentle pulse
  const imageVariants = {
    animate: {
      scale: [1, 1.06, 1],
      transition: {
        repeat: Infinity,
        duration: 2.5,
        ease: 'easeInOut',
      },
    },
  };

  // Heartbeat line wave animation (kept exactly the same)
  const pathVariants = {
    initial: { pathLength: 0, opacity: 0 },
    animate: {
      pathLength: 1,
      opacity: 1,
      transition: {
        pathLength: { duration: 2, repeat: Infinity, ease: 'linear' },
        opacity: { duration: 0.5, repeat: Infinity },
      },
    },
  };

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-[#fff5f5] via-[#ffebee] to-[#fddada] flex items-center justify-center z-50">
      <motion.div
        variants={containerVariants}
        initial="initial"
        animate="animate"
        className="text-center"
      >
        {/* Your Image with Glow & Pulse */}
        <motion.img
          src="/logo2.png"
          alt="Pharmacy Logo"
          variants={imageVariants}
          animate="animate"
          className="w-24 h-24 md:w-48 md:h-48 object-contain mx-auto "
          style={{
            filter: 'drop-shadow(0 0 50px rgba(229, 57, 53, 0.5))',
          }}
        />

        {/* Pulsing Heartbeat Line (exactly as before) */}
        <div className="relative w-80 h-20 mx-auto overflow-hidden">
          <svg width="320" height="80" viewBox="0 0 320 80" className="absolute inset-0">
            <motion.path
              d="M0,40 L60,40 L80,10 L100,70 L120,30 L140,40 L320,40"
              stroke="#ff6f60"
              strokeWidth="4"
              fill="none"
              strokeLinecap="round"
              variants={pathVariants}
              initial="initial"
              animate="animate"
            />
            <motion.path
              d="M0,40 L60,40 L80,10 L100,70 L120,30 L140,40 L320,40"
              stroke="#e53935"
              strokeWidth="4"
              fill="none"
              strokeLinecap="round"
              variants={pathVariants}
              initial="initial"
              animate="animate"
              transition={{ delay: 0.5 }}
              style={{ filter: 'blur(4px)' }} // Soft glow effect
            />
          </svg>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 1 }}
          className="mt-12 text-xl font-medium text-[#c62828] tracking-wider"
        >
          Preparing your store...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default Loader;